/**
 * Processes chart data to ensure proper visualization
 * Handles edge cases like single data points
 */
export const processChartData = (data: any) => {
  // Make a deep copy of the data to avoid modifying the original
  const processedData = JSON.parse(JSON.stringify(data));

  // Check if we only have one data point
  if (processedData.labels.length === 1) {
    // Duplicate the label with a slight modification to indicate it's the same point
    processedData.labels.push(`${processedData.labels[0]}`);

    // Duplicate each dataset's data point
    processedData.datasets.forEach((dataset: any) => {
      if (dataset.data && dataset.data.length === 1) {
        dataset.data.push(dataset.data[0]);
      }
    });

    return processedData;
  }

  return data;
};
